import React, { useState, useEffect } from "react";

import {
  Typography,
  ListItem,
  Button,
  Divider,
  Collapse,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  TextField,
  Chip,
  InputLabel,
  Select,
  MenuItem,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  IconButton,
  Avatar,
  Tooltip,
  Checkbox,
} from "@material-ui/core";
import AddFilter from "./AddFilter";
import axios, { reportClient } from "../../../AxiosClient";
import { Check } from "@material-ui/icons";
import { useTranslation, Trans } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: 150,
  },
  existingContainer: {
    display: "flex",
    flex: 1,
    minHeight: 250,
  },
  list: {
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
    flex: 1,
  },
  selectSource: {
    textAlign: "center",
    justifyContent: "center",
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  existing: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: 10,
  },
  newButton: {
    margin: "10px auto",
  },
  collapse: {
    marginTop: 15,
  },
  expansionPanel: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  },
  expansionPanelExpanded: {
    margin: "0 !important",
  },
  expansionPanelSummary: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
  },
  formControl: {
    marginBottom: 5,
  },
}));

const redirect = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? ":" + window.location.port : ""
}/oauth2/redirect`;
function DataSourceDefinition(props) {
  const classes = useStyles();
  const [token, setToken] = useState(null);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  // const [authentication, setAuthentication] = useState({
  //   requestTokenMethod: "Parameters",
  //   authMethod: "None",
  //   type: "Document",
  //   query: "Favourites",
  //   radioChoice: "Internal",
  //   oAuthFilters: [],
  //   oAuthTokenFilters: [],
  //   authentication: "",
  //   radioDataSendMethodChange: "Parameters",
  //   oAuthURL: "",
  //   oAuthIdName: "client_id",
  //   oAuthId: "",
  //   redirectParamName: "redirect_uri",
  //   token: "",
  //   respondTokenName: "access_token",
  //   apiKeyMethod: "Parameter",
  //   apiKeyParamName: "apikey",
  //   apiKeyValue: "",
  //   username: "",
  //   password: "",
  //   state: null,
  //   codeVerifier: null,
  //   codeChallenge: null,
  // });
  const { t } = useTranslation();

  // useEffect(
  //   () => {
  //     props.onAuthenticationUpdate(authentication);
  //   },
  //   [authentication]
  // );

  useEffect(
    () => {
      props.onNameUpdate(name);
    },
    [name]
  );
  useEffect(
    () => {
      props.onDescriptionUpdate(description);
    },
    [description]
  );
  useEffect(
    () => {
      props.onTokenUpdate(token);
    },
    [token]
  );

  const handleAddFilter = (name) => (filter) => {
    let filters = props.authentication[name].splice(0);
    filters = [...filters, filter];
    let authentication = { ...props.authentication, [name]: filters };
    props.onAuthenticationUpdate(authentication);
  };

  const handleDeleteFilter = (index) => {
    let newFilters = JSON.parse(
      JSON.stringify(props.authentication.oAuthFilters)
    );
    newFilters.splice(index, 1);
    let authentication = { ...props.authentication, oAuthFilters: newFilters };
    props.onAuthenticationUpdate(authentication);
  };

  const handleDeleteTokenFilter = (index) => {
    let newFilters = JSON.parse(
      JSON.stringify(props.authentication.oAuthTokenFilters)
    );
    newFilters.splice(index, 1);
    let authentication = {
      ...props.authentication,
      oAuthTokenFilters: newFilters,
    };
    props.onAuthenticationUpdate(authentication);
  };

  const authGraphDomain = () => {
    let oAuthURL = props.authentication.oAuthAuthURL;
    oAuthURL =
      oAuthURL +
      "?response_type=code&code_challenge=" +
      props.authentication.codeVerifier +
      "&code_challenge_method=S256&state=" +
      props.authentication.state +
      "&redirect_uri=" +
      encodeURIComponent(redirect);
    props.authentication.oAuthFilters.map(
      (filter) =>
        (oAuthURL =
          oAuthURL + "&" + filter.filterName + "=" + filter.filterValue)
    );
    openPopup(
      oAuthURL,
      (location) => {
        let url = new URL(location);
        let split = url.href.split("code=");
        split = split[1].split("&");
        let code = split[0];

        let body = { code, redirect_uri: redirect };
        props.authentication.oAuthTokenFilters.map((filter) => {
          body[filter.name] = filter.value;
        });
        axios
          .post(props.authentication.oAuthTokenURL, body, body)
          .then((res) => {
            setToken(res.data.access_token);
          });
      },
      (message) => {
        console.log(message);
      }
    );
  };

  const openPopup = (
    url,
    successCallback,
    errCallback,
    redirectUrl = redirect
  ) => {
    let popUpWidth = 483;
    let popUpHeight = 600;
    let winLeft = window.screenLeft ? window.screenLeft : window.screenX;
    let winTop = window.screenTop ? window.screenTop : window.screenY;
    let width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    let height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    let left = width / 2 - popUpWidth / 2 + winLeft;
    let top_1 = height / 2 - popUpHeight / 2 + winTop;
    let popup = window.open(
      url,
      "",
      "width=" +
        popUpWidth +
        ", height=" +
        popUpHeight +
        ", top=" +
        top_1 +
        ", left=" +
        left
    );
    var pollTimer = window.setInterval(() => {
      if (popup && popup.closed) {
        window.clearInterval(pollTimer);
        errCallback();
      } else {
        try {
          var popUpWindowLocation = popup.location;
          if (popUpWindowLocation.href.indexOf(redirectUrl) !== -1) {
            window.clearInterval(pollTimer);
            popup.close();
            successCallback(popUpWindowLocation);
          }
        } catch (e) {
          // we will catch a cross origin error every time we try to access the popup until it redirects, ignore it
        }
      }
    }, 1);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
      {/* <FormControl component="fieldset" className={classes.formControl}>
        <TextField
          onChange={(e) => {
            setName(e.target.value);
          }}
          value={name}
          type="name"
          label={t("report_datasource_name")}
        />
      </FormControl>
      <FormControl component="fieldset" className={classes.formControl}>
        <TextField
          onChange={(e) => {
            setDescription(e.target.value);
          }}
          value={description}
          type="description"
          label={t("report_datasource_description")}
        />
      </FormControl> */}

      {/* <FormControl
        component="fieldset"
        className={classes.formControl}
        style={{ marginTop: 15 }}
      > */}
      {/* <FormLabel component="legend">{t("report_datasource")}</FormLabel>
        <RadioGroup
          style={{
            display: "flex",
            flexDirection: "row",
          }}
          onChange={(event) =>
            setAuthentication({
              ...authentication,
              radioChoice: event.target.value,
            })
          }
          aria-label="gender"
          name="customized-radios"
          value={authentication.radioChoice}
        >
          <FormControlLabel
            value="Internal"
            control={<Radio />}
            label={t("report_datasource_internal")}
          />
          <FormControlLabel
            value="External"
            control={<Radio />}
            label={t("report_datasource_external")}
          />
        </RadioGroup>
      </FormControl> */}
      <Collapse in={props.authentication.radioChoice}>
        {props.authentication.radioChoice === "External" && (
          <FormControl component="fieldset" className={classes.formControl}>
            <FormLabel component="legend">{t("report_auth_type")}</FormLabel>
            <RadioGroup
              style={{ display: "flex", flexDirection: "row" }}
              value={props.authentication.authMethod}
              onChange={(event) =>
                props.onAuthenticationUpdate({
                  ...props.authentication,
                  authMethod: event.target.value,
                })
              }
              aria-label="gender"
              name="customized-radios"
            >
              <FormControlLabel value="None" control={<Radio />} label="None" />
              <FormControlLabel
                value="OAuth"
                control={<Radio />}
                label="OAuth"
              />
              <FormControlLabel
                value="ApiKey"
                control={<Radio />}
                label="Api key"
              />
              <FormControlLabel
                value="Login"
                control={<Radio />}
                label="Login"
              />
            </RadioGroup>
          </FormControl>
        )}
      </Collapse>
      <Collapse
        in={
          props.authentication.authMethod &&
          props.authentication.radioChoice === "External"
        }
      >
        <div
          style={{
            flexDirection: "column",
            display: "flex",
          }}
        >
          {props.authentication.authMethod === "OAuth" ? (
            <>
              <FormControl component="fieldset" className={classes.formControl}>
                <TextField
                  onChange={(e) =>
                    props.onAuthenticationUpdate({
                      ...props.authentication,
                      oAuthAuthURL: e.target.value,
                    })
                  }
                  value={props.authentication.oAuthAuthURL}
                  label={t("report_authentication_authorization_endpoint")}
                  defaultValue="https://"
                />
              </FormControl>
              <FormControl component="fieldset" className={classes.formControl}>
                <TextField
                  onChange={(e) =>
                    props.onAuthenticationUpdate({
                      ...props.authentication,
                      oAuthTokenURL: e.target.value,
                    })
                  }
                  value={props.authentication.oAuthTokenURL}
                  label={t("report_authentication_token_endpoint")}
                  defaultValue="https://"
                />
              </FormControl>
              <FormControl component="fieldset" className={classes.formControl}>
                <div>
                  {props.authentication.oAuthFilters.map((filter, index) => (
                    <Chip
                      onDelete={() => handleDeleteFilter(index)}
                      style={{ margin: 2 }}
                      label={filter.filterName + ": " + filter.filterValue}
                    />
                  ))}
                </div>
                <AddFilter handleAddFilter={handleAddFilter("oAuthFilters")} />
              </FormControl>
              <FormControl component="fieldset" className={classes.formControl}>
                <div>
                  {props.authentication.oAuthTokenFilters.map(
                    (filter, index) => (
                      <Chip
                        onDelete={() => handleDeleteTokenFilter(index)}
                        style={{ margin: 2 }}
                        label={filter.filterName + ": " + filter.filterValue}
                      />
                    )
                  )}
                </div>
                <AddFilter
                  handleAddFilter={handleAddFilter("oAuthTokenFilters")}
                />
              </FormControl>
              <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">
                  {t("report_request_token_method")}
                </FormLabel>
                <RadioGroup
                  style={{ display: "flex", flexDirection: "row" }}
                  value={props.authentication.requestTokenMethod}
                  onChange={(event) =>
                    props.onAuthenticationUpdate({
                      ...props.authentication,
                      requestTokenMethod: event.target.value,
                    })
                  }
                  aria-label="Request token method"
                  name="customized-radios"
                >
                  <FormControlLabel
                    value="Header"
                    control={<Radio />}
                    label={t("report_request_token_method_header")}
                  />
                  <FormControlLabel
                    value="Parameters"
                    control={<Radio />}
                    label={t("report_send_method_parameters")}
                  />
                </RadioGroup>
              </FormControl>
              <FormControl
                component="fieldset"
                className={classes.formControl}
                style={{ flexDirection: "column", display: "flex" }}
              >
                <Button onClick={authGraphDomain} color="primary" autoFocus>
                  {t("report_get_token")}
                </Button>
                {token && <Check />}
              </FormControl>
            </>
          ) : props.authentication.authMethod === "Login" ? (
            <>
              <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">
                  {t("report_send_method")}
                </FormLabel>
                <RadioGroup
                  style={{ display: "flex", flexDirection: "row" }}
                  onChange={(event) =>
                    props.onAuthenticationUpdate({
                      ...props.authentication,
                      radioDataSendMethodChange: event.target.value,
                    })
                  }
                  aria-label="gender"
                  name="customized-radios"
                  value={props.authentication.radioDataSendMethodChange}
                >
                  <FormControlLabel
                    value="Parameters"
                    control={<Radio />}
                    label={t("report_send_method_parameters")}
                  />
                  <FormControlLabel
                    value="Body"
                    control={<Radio />}
                    label={t("report_send_method_body")}
                  />
                </RadioGroup>
              </FormControl>
              <FormControl component="fieldset" className={classes.formControl}>
                <TextField
                  onChange={(e) => {
                    props.onAuthenticationUpdate({
                      ...props.authentication,
                      username: e.target.value,
                    });
                  }}
                  value={props.authentication.username}
                  label={t("report_authentication_username")}
                />
              </FormControl>
              <FormControl component="fieldset" className={classes.formControl}>
                <TextField
                  onChange={(e) => {
                    props.onAuthenticationUpdate({
                      ...props.authentication,
                      password: e.target.value,
                    });
                  }}
                  value={props.authentication.password}
                  type="password"
                  label={t("report_authentication_password")}
                />
              </FormControl>
            </>
          ) : props.authentication.authMethod === "ApiKey" ? (
            <>
              <FormControl component="fieldset" className={classes.formControl}>
                <TextField
                  onChange={(e) => {
                    props.onAuthenticationUpdate({
                      ...props.authentication,
                      apiKeyParamName: e.target.value,
                    });
                  }}
                  value={props.authentication.apiKeyParamName}
                  label={t("report_authetication_apikeyname")}
                />
              </FormControl>
              <FormControl component="fieldset" className={classes.formControl}>
                <TextField
                  onChange={(e) => {
                    props.onAuthenticationUpdate({
                      ...props.authentication,
                      apiKeyValue: e.target.value,
                    });
                  }}
                  value={props.authentication.apiKeyValue}
                  label={t("report_authentication_apikeyvalue")}
                />
              </FormControl>
              <FormControl component="fieldset" className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">
                  {t("report_authetication_apikeymethod")}
                </InputLabel>
                <Select
                  value={props.authentication.apiKeyMethod}
                  MenuProps={{
                    style: { zIndex: 1310 },
                  }}
                  onChange={(event) =>
                    props.onAuthenticationUpdate({
                      ...props.authentication,
                      apiKeyMethod: event.target.value,
                    })
                  }
                  inputProps={{
                    name: "apiKeyMethod",
                    id: "apiKeyMethod",
                  }}
                >
                  <MenuItem key="fontSize" value={"Parameter"}>
                    {t("report_send_method_parameters")}
                  </MenuItem>
                  <MenuItem key="fontSize" value={"Header"}>
                    {t("report_request_token_method_header")}
                  </MenuItem>
                </Select>
              </FormControl>
            </>
          ) : null}
        </div>
      </Collapse>

      {/* <div style={{ width: "100%" }}>
        <Button
          style={{ width: "100%" }}
          onClick={props.onSave}
          startIcon={<Check />}
        >
          Save Definition
        </Button>
      </div> */}
    </div>
  );
}

export default DataSourceDefinition;
